import React from 'react';

const Navigation = ({ currentView, onViewChange, user, setRequireAuth }) => {
    const handleNavigation = (view) => {
        // These views require authentication
        const authViews = ['matches-page', 'agenda', 'personal-profile'];
        
        if (authViews.includes(view) && !user) {
            setRequireAuth(true);
            return;
        }
        
        onViewChange(view);
    };

    return (
        <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200">
            <div className="max-w-md mx-auto px-4">
                <div className="flex justify-around py-3">
                    <button
                        onClick={() => handleNavigation('agenda')}
                        className={`flex flex-col items-center space-y-1 ${
                            currentView === 'agenda' 
                                ? 'text-purple-600' 
                                : 'text-gray-400 hover:text-gray-600'
                        }`}
                    >
                        <i className="fas fa-calendar-alt text-xl"></i>
                        <span className="text-xs font-medium">Agenda</span>
                    </button>

                    <button
                        onClick={() => handleNavigation('home')}
                        className={`flex flex-col items-center space-y-1 ${
                            currentView === 'home' 
                                ? 'text-purple-600' 
                                : 'text-gray-400 hover:text-gray-600'
                        }`}
                    >
                        <i className="fas fa-home text-xl"></i>
                        <span className="text-xs font-medium">Home</span>
                    </button>

                    <button
                        onClick={() => handleNavigation('matches-page')}
                        className={`flex flex-col items-center space-y-1 ${
                            currentView === 'matches-page' 
                                ? 'text-purple-600' 
                                : 'text-gray-400 hover:text-gray-600'
                        }`}
                    >
                        <i className="fas fa-sync-alt text-xl"></i>
                        <span className="text-xs font-medium">Matches</span>
                    </button>
                </div>
            </div>
        </nav>
    );
};

export default Navigation;